<template>
  <div>
  <Card>
      <Row>
        <i-col span="18">
          <Form ref="searchForm" inline :model="searchForm" :label-width="60" @submit.native.prevent>
            <FormItem label="用户名" prop="name">
              <i-input v-model="searchForm.name" placeholder="请输入用户名" style="width: 200px;"></i-input>
            </FormItem>
            <FormItem :label-width="0">
              <Button type="primary" @click="getSpringBoradUserList()">搜索</Button>
              <Button @click="searchReset" style="margin-left: 10px;">重置</Button>
            </FormItem>
          </Form>
        </i-col>
        <i-col span="6">
          <Button style="float: right;" @click="addUser" type="primary" :style="{marginBottom: '10px'}">添加</Button>
        </i-col>
       </Row>
      <tables search-place="top" v-model="tableData" :columns="columns" @on-sort-change="changeSort"/>
      <Row style="margin: 10px;">
        <div style="float: right;">
          <page :total="count" :current="page" :page-size="size" @on-change="getSpringBoradUserList"></page>
        </div>
     </Row>
      <Drawer
        title="添加"
        v-model="change"
        width="720"
        :mask-closable="true"
        @on-close="drawerClose"
      >
        <i-form ref="formItem" :model="formItem" :label-width="100" :rules="ruleValidate">
          <form-item label="用户" prop="username">
             <i-select v-model="formItem.username" style="width:90%;" placeholder="请选择用户">
              <i-option v-for="item in user_all" :value="item.username" :key="item.username" :label="item.username"></i-option>
             </i-select>
          </form-item>
          <FormItem label="过期时间" prop="date_active">
            <DatePicker type="date" placeholder="Select date"  format="yyyy年MM月dd日" v-model="formItem.date_active"></DatePicker>
          </FormItem>
          <form-item>
           <i-button type="primary" @click="handleSubmit('formItem')">提交</i-button>
           <i-button style="margin-left: 8px" @click="change=false">取消</i-button>
          </form-item>
        </i-form>
        <spin fix v-if="changeLoadingShow">
          <Icon type="load-c" size=18 class="demo-spin-icon-load"></Icon>
          <div>请求中</div>
        </spin>
      </Drawer>
    </Card>
  </div>
</template>
<script>
import Tables from '_c/tables'
import { GetALLUsers } from '@/api/user'
import { getSpringBoardUserList, saveSpringBoardUser, deleteSpringBoardUser, editSpringBoardUser } from '@/api/springboard'
import dayjs from 'dayjs'
export default {
  name: 'SpringBoardUserList',
  components: {
    Tables
  },
  data () {
    return {
      count: 1,
      size: 10,
      page: 1,
      change: false,
      ordering: null,
      columns: [
        { title: 'ID', key: 'user_id', align: 'center', sortable: 'custom' },
        { title: '用户名', key: 'user', align: 'center' },
        { title: '主机', key: 'asset', align: 'center' },
        { title: '过期时间', key: 'time_active', align: 'center' },
        {
          title: '操作',
          align: 'center',
          render: (h, params) => {
            if (this.$store.state.user.superuser) {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    title: 'Edit'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.editUser(params)
                    }
                  }
                }, 'Edit'),
                h('Poptip', {
                  props: {
                    confirm: true,
                    placement: 'bottom',
                    title: '你确定要删除吗?',
                    transfer: true
                  },
                  on: {
                    'on-ok': () => {
                      this.deleteUser(params.row.user_id)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small',
                      title: 'Delete'
                    },
                    style: {
                      marginRight: '5px'
                    }
                  }, 'Delete')
                ])
              ])
            } else {}
          }
        }
      ],
      tableData: [],
      user_all: [],
      changeLoadingShow: false,
      searchForm: {
        name: null
      },
      formItem: {
        userId: null,
        username: '',
        date_active: ''
      },
      listStyle: {
        width: '250px',
        height: '300px'
      },
      ruleValidate: {
        username: [{ required: true, message: '用户不能为空 !', trigger: 'change' }],
        date_active: [{ required: true, type: 'date', message: '请选择用户过期时间', trigger: 'change' }]
      }
    }
  },
  methods: {
    getSpringBoradUserList (value = 1) {
      this.page = value
      let params = {
        page: this.page,
        ordering: this.ordering,
        search: this.searchForm.name
      }
      getSpringBoardUserList(params).then(res => {
        this.tableData = res.data.results
        this.tableData.map((item, index) => {
          item['asset'] = item.perm_info.assets ? Object.keys(item.perm_info.assets).length : 0
        })
        this.count = res.data.count
      })
    },
    addUser () {
      this.formItem.userId = null
      this.change = true
    },
    editUser (params) {
      this.formItem.username = params.row.user
      this.formItem.date_active = new Date(params.row.time_active)
      this.formItem.userId = params.row.user_id
      this.change = true
    },
    deleteUser (id) {
      deleteSpringBoardUser(id).then(res => {
        if (res.data.code === 200) {
          this.$Message.success(res.data.msg)
          this.getSpringBoradUserList()
        } else {
          this.$Message.error(res.data.msg)
        }
      })
    },
    drawerClose () {
      let that = this.formItem
      that.username = ''
      that.date_active = ''
      that.userId = null
    },
    fetchAllUserData () {
      GetALLUsers().then(res => {
        this.user_all = res.data
      })
    },
    changeSort (column) {
      if (column.key === 'user_id') {
        if (column.order === 'asc') {
          this.ordering = 'user_id'
        } else {
          this.ordering = '-user_id'
        }
      }
      this.getSpringBoradUserList()
    },
    searchReset () {
      this.searchForm.name = null
    },
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.formItem.date_active = dayjs(this.formItem.date_active).format('YYYY-MM-DD')
          this.changeLoadingShow = true
          if (this.formItem.userId) {
            editSpringBoardUser(this.formItem).then(res => {
              if (res.data.code === 200) {
                this.change = false
                this.getSpringBoradUserList()
              } else {
                // this.$Notice.error({title: res.data})
                this.$Message.error(res.data.msg)
              }
            }).catch(res => {
              console.log(res.response)
              this.$Notice.error({
                title: '操作失败！ 错误状态码:' + res.request.status,
                desc: res.request.responseText
              })
            })
          } else {
            saveSpringBoardUser(this.formItem).then(res => {
              if (res.data.code === 200) {
                this.change = false
                this.getSpringBoradUserList()
              } else {
                // this.$Notice.error({title: res.data})
                this.$Message.error(res.data.msg)
              }
            }).catch(res => {
              console.log(res.response)
              this.$Notice.error({
                title: '操作失败！ 错误状态码:' + res.request.status,
                desc: res.request.responseText
              })
            })
          }
        } else {
          this.$Notice.error({title: '请检查输入框！'})
        }
        this.changeLoadingShow = false
      })
    }
  },
  mounted: function () {
    this.fetchAllUserData()
    this.getSpringBoradUserList()
  }
}
</script>

<style>
.ivu-poptip-body {
  text-align: left !important;
}
</style>
